import mainStage from "./_mainStage.script.js";

mainStage.init();
